module.exports = "<div class=\"panel\" data-bind=\"visible: visible, attr: {'component_name':componentName,'id': id}\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <span class=\"appTitle\" data-bind=\"text: context.name\"></span>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/header/header.html
// module id = 647
// module chunks = 0